import { useLocation, useNavigate } from "react-router-dom";

import { GET } from "./useAxiosQuery";
import { system_id, userData } from "./companyInfo";

export default function useCheckUserPermission(moduleName, moduleCode) {
	const location = useLocation();
	const navigate = useNavigate();

	const { data: dataPermissions, refetch: refetchPermissions } = GET(
		`api/user_permission?system_id=${system_id}&user_id=${userData().id}`,
		"check_user_permissions",
		(res) => {
			if (res.data) {
				let data = res.data;

				let excludeUrl = ["/edit-profile", "/dashboard"];

				if (!excludeUrl.includes(location.pathname)) {
					if (data.length) {
						let dataPermissionsFilter = data.filter(
							(f) =>
								f.module_code === moduleCode &&
								f.module_buttons.filter(
									(f2) =>
										f2.mod_button_code === "view_page" &&
										parseInt(f2.status) === 1
								).length > 0
						);

						if (dataPermissionsFilter.length) {
							dataPermissionsFilter[0].module_buttons.forEach((el) => {
								setTimeout(() => {
									if (el.mod_button_code === "btn_add") {
										let btnAdd = document.querySelectorAll("[name=btn_add]");
										if (btnAdd.length) {
											btnAdd.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = [];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_edit") {
										let btnEdit = document.querySelectorAll("[name=btn_edit]");
										if (btnEdit.length) {
											btnEdit.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = [];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_delete") {
										let btnDelete =
											document.querySelectorAll("[name=btn_delete]");
										if (btnDelete.length) {
											btnDelete.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}
									}
									if (el.mod_button_code === "btn_status") {
										let btnStatus =
											document.querySelectorAll("[name=btn_status]");
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}
									}
									if (el.mod_button_code === "btn_preview") {
										let btnStatus =
											document.querySelectorAll("[name=btn_preview]");
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = ["Evaluation - View"];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_add_category") {
										let btnStatus = document.querySelectorAll(
											"[name=btn_add_category]"
										);
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = ["Evaluation Category - Add"];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_edit_category") {
										let btnStatus = document.querySelectorAll(
											"[name=btn_edit_category]"
										);
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = ["Evaluation Category - Edit"];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_delete_category") {
										let btnStatus = document.querySelectorAll(
											"[name=btn_delete_category]"
										);
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}
									}
									if (el.mod_button_code === "btn_view_category") {
										let btnStatus = document.querySelectorAll(
											"[name=btn_view_category]"
										);
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}

										if (parseInt(el.status) === 0) {
											let moduleNames = ["Evaluation Category - View"];
											if (moduleNames.includes(moduleName)) {
												navigate(-1);
											}
										}
									}
									if (el.mod_button_code === "btn_status_category") {
										let btnStatus = document.querySelectorAll(
											"[name=btn_status_category]"
										);
										if (btnStatus.length) {
											btnStatus.forEach((elem) => {
												if (parseInt(el.status) === 0) {
													elem.remove();
												} else {
													elem.classList.remove("hide");
												}
											});
										}
									}
								}, 500);
							});
						} else {
							navigate("/404");
						}
					} else {
						navigate("/");
					}
				}
			}
		},
		false
	);

	return { dataPermissions, refetchPermissions };
}
